import { IMicroGallery } from "../../feature/MicroGallery/MicroGallery";

export const influencerWelcomeGalleryImages: IMicroGallery = {
  preText: "Loved by over 21,249 happy, healthy cats.",
  images: [
    {
      src: "https://a.storyblok.com/f/176726/2992x2992/4933e3d344/cat-on-boxes.jpg?cv=1746787775677/m/300x300",
      width: 300,
      height: 300,
    },
    {
      src: "https://a.storyblok.com/f/176726/1536x2049/6fb8dd9a0e/cat-in-field.JPG/m/300x300",
      width: 300,
      height: 300,
    },
    {
      src: "https://a.storyblok.com/f/176726/3024x4032/c2c57852b7/white-cat-on-box.jpeg/m/300x300",
      width: 300,
      height: 300,
    },
    {
      src: "https://a.storyblok.com/f/176726/1125x1263/2f3eb4e27a/cat-with-nibbles.jpeg/m/300x300",
      width: 300,
      height: 300,
    },
  ],
  title: "Review your plan",
  body: "Your trial box will arrive on Fri Mar 3 2023. After that, you’ll receive 28 trays every 28 days.",
};
